module.exports = __webpack_public_path__ + "static/filmdrop-ui-campfire-c07fa94fc3c34c3cdef76e6cdb9f23ba.jpg";